
import { Route } from '@/app/router'

const Parts = () => import('./index.vue')

const PartsMeta = {
	sort: 9,
	displayInSidebar: true,
	displayName: 'part',
	icon: 'fal wrench',
	activeIcon: 'fas wrench'
}

const PartsProps = ['page', 'perPage']

export default new Route('/parts', Parts)
	.as('Dashboard:Parts')
	.meta(PartsMeta)
	.props(PartsProps)
	.permissions(['SHOW_PARTS'])
